import React, { useEffect, useState } from 'react'
import ModalActionButton from '../../elements/ModalActionButton'
import { useDispatch, useSelector } from 'react-redux'
import { fetchStaff } from '../../../store/actions/staffActions'
import InlinePreloader from '../../elements/InlinePreloader'
import AutocompleteSelect from '../../elements/form/AutocompleteSelect'
import { ERROR, SET_SUCCESS } from '../../../store/types'
import axios from 'axios'
import { authHeader } from '../../../utils'

const ClassTeacherAssignment = ({close, reload, activeClass, subject}) => {
    const dispatch = useDispatch()
    // const subjectsSelector = useSelector(state => state.subjects)
    const staffSelector = useSelector((state => state.staff))
    const [teacher, setTeacher] = useState('')
    const [validationErrors, setValidationErrors] = useState({})

    const validateForm = () => {
        let errors = {}
        if(teacher === '') {
            errors.teacher = true
        }
        setValidationErrors(errors)
        return errors
    }

    useEffect(() => {
        dispatch(fetchStaff(`onboarded=true&staffType=ACADEMIC`, 0, 0))

        return () => {
            
        }
    }, [dispatch])

    const [processing, setProcessing] = useState(false)
    const pushAssignment = async () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            })
            return
        }
        try {
            const payload = {
                teacher,
                class: activeClass._id
            }
            const headers = authHeader()
            setProcessing(true)
            await axios.post(`${process.env.REACT_APP_BASE_URL}/subjects/${subject._id}/assign-teacher`, payload, {headers})
            setProcessing(false)
            dispatch({
                type: SET_SUCCESS,
                payload: 'Class teacher assigned successfully'
            })
            reload()
            close()
        } catch (error) {
            setProcessing(false)
            dispatch({
                type: ERROR,
                error
            })
        }
    }

    return (
        <div>
            <div className='w-full'>
                <p className='text-sm'>Select a member of staff below to teach {subject.name} to {activeClass.name} students.</p>
                {staffSelector?.loadingStaff 
                    ? 
                        <InlinePreloader />
                    : 
                        <>
                        {staffSelector?.staffMembers?.staff?.length > 0 && <div className='mt-4 relative'>
                            <AutocompleteSelect
                                selectOptions = {staffSelector?.staffMembers?.staff}
                                inputLabel = "Subject Teacher"
                                requiredField={true}
                                titleField = "fullName"
                                displayImage = {false}
                                imageField = ""
                                placeholderText={`Select a member of staff`}
                                fieldId = {`class-parent`}
                                preSelected={''}
                                preSelectedLabel='_id'
                                hasError = {validationErrors && validationErrors.teacher}
                                returnFieldValue={(value)=>{setTeacher(value._id)}}
                            />
                        </div>}
                        
                        {staffSelector?.staffMembers?.staff?.length === 0 && 
                            <div className='w-full mt-[20px] p-[15px] bg-gray-50 border border-gray-400 rounded-[8px] bg-opacity-'>
                            <h3 className='text-sm text-gray-600 font-[500] tracking-tight'>No eligible staff found</h3>
                            <p className='text-sm font-[500] text-gray-500'>The staff must be fully onboarded on this system and be an academic staff</p>
                            </div>
                        }
                        </>
                    }
                </div>

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Assign Teacher for ${activeClass.name} - ${subject.name}`}
                    buttonAction={()=>{pushAssignment()}}
                    processing={processing}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={()=>{close()}}
                >
                    Close
                </button>
                
            </div>
        </div>
    )
}

export default ClassTeacherAssignment